const SvgArrowBackSmall = () => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 17 16">
    <path fill="#373737" fillRule="evenodd" d="m6.5 1.5.706.706L1.914 7.5 16 7.5l.002.998L1.91 8.497l5.296 5.297-.706.706L0 8z" clipRule="evenodd" />
  </svg>;
export default SvgArrowBackSmall;